// Re-export fino (Sprint 5 Task 2, TUT-211): o componente vive em
// @brevi/ui-kit; nenhum dos importadores do app mudou nesta fatia.
export * from "@brevi/ui-kit/ui/separator";
